import {
  ButtonProps,
  Drawer,
  DrawerProps,
  Edit,
  FormProps,
  Grid
} from '@pankod/refine-antd'
import { BannersForm } from './form'

type BannerEditProps = {
  drawerProps: DrawerProps
  formProps: FormProps
  saveButtonProps: ButtonProps
}

export const BannerEditDrawer: React.FC<BannerEditProps> = ({
  drawerProps,
  formProps,
  saveButtonProps
}) => {
  const breakpoint = Grid.useBreakpoint()

  return (
    <Drawer
      {...drawerProps}
      width={breakpoint.sm ? '600px' : '100%'}
      bodyStyle={{ padding: 0 }}
      zIndex={1001}
    >
      <Edit
        saveButtonProps={saveButtonProps}
        headerButtons={() => (<></>)}
      >
        <BannersForm
          formProps={formProps}
        />
      </Edit>
    </Drawer>
  )
}
